import {
  Award,
  BadgeCheck,
  BatteryCharging,
  BookMarked,
  Building2,
  CalendarClock,
  Cctv,
  Circle,
  CircleCheckBig,
  ClipboardEdit,
  ClipboardList,
  Clock,
  CloudOff,
  Coins,
  Factory,
  FileCheck2,
  FileStack,
  FileText,
  Gauge,
  GraduationCap,
  HeartPulse,
  Hotel,
  Landmark,
  Laptop,
  LineChart,
  Lock,
  MonitorSmartphone,
  PackageCheck,
  RadioTower,
  Recycle,
  Scale,
  SearchCheck,
  Server,
  ShieldCheck,
  ShoppingBag,
  Trees,
  Truck,
  Users,
  Wrench,
} from 'lucide-react';

/**
 * Registry of every icon referenced by name from src/data/*.
 * Kept as explicit named imports (rather than `import * as`) so the bundler
 * ships only these icons instead of the whole lucide set.
 * Add an entry here when a data module starts using a new icon.
 */
const registry = {
  Award,
  BadgeCheck,
  BatteryCharging,
  BookMarked,
  Building2,
  CalendarClock,
  Cctv,
  CircleCheckBig,
  ClipboardEdit,
  ClipboardList,
  Clock,
  CloudOff,
  Coins,
  Factory,
  FileCheck2,
  FileStack,
  FileText,
  Gauge,
  GraduationCap,
  HeartPulse,
  Hotel,
  Landmark,
  Laptop,
  LineChart,
  Lock,
  MonitorSmartphone,
  PackageCheck,
  RadioTower,
  Recycle,
  Scale,
  SearchCheck,
  Server,
  ShieldCheck,
  ShoppingBag,
  Trees,
  Truck,
  Users,
  Wrench,
};

/** Render a registered icon by its string name. */
export default function Icon({ name, className = 'h-5 w-5', strokeWidth = 1.75, ...rest }) {
  const Component = registry[name] || Circle;
  return <Component className={className} strokeWidth={strokeWidth} aria-hidden="true" {...rest} />;
}
